<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ModuleAdministratorsEdition',
  computed: {
    ...mapState('administrator/item', [
      'item',
    ]),
    first_name: {
      get () {
        return this.item.first_name;
      },
      set (value) {
        const { item } = this;
        item.first_name = value;
        this.setItem(item);
      },
    },
    last_name: {
      get () {
        return this.item.last_name;
      },
      set (value) {
        const { item } = this;
        item.last_name = value;
        this.setItem(item);
      },
    },
    email: {
      get () {
        return this.item.email;
      },
      set (value) {
        const { item } = this;
        item.email = value;
        this.setItem(item);
      },
    },
    password: {
      get () {
        return this.item.plainPassword;
      },
      set (value) {
        const { item } = this;
        item.plainPassword = value;
        item.password1 = value;
        item.password2 = value;
        this.setItem(item);
      },
    },
    passwordPlaceholder() {
      if (this.item.id) {
        return 'Leave blank if you don not want to change the password';
      }

      return 'Enter user password';
    },
  },
  methods: {
    ...mapActions('administrator/item', [
      'save',
      'fetch',
    ]),
    ...mapMutations('administrator/item', [
      'setItem',
      'reset',
    ]),
    localSave () {
      const payload = {
        email: this.item.email,
        first_name: this.item.first_name,
        last_name: this.item.last_name,
        password: this.item.password,
      };

      if (this.item.id) {
        payload.id = this.item.id;
      }

      this.save(payload)
        .then(() => {
          // if (payload.id) {
          //   return;
          // }

          this.$router.push({ name: 'administrators-listing' });
        })
      ;
    },
  },
  created() {
    const { id } = this.$route.params;

    if (!id) {
      this.reset();
      return;
    }

    this.fetch(id);
  },
};
</script>
<template>
  <div class="box">
    <h2>General</h2>
    <div class="form-group mt-3">
      <label for="first_name" class="d-block">First Name</label>
      <input id="first_name" class="form-control rounded-0" v-model="first_name" />
    </div>
    <div class="form-group mt-3">
      <label for="last_name" class="d-block">Last Name</label>
      <input id="last_name" class="form-control rounded-0" v-model="last_name" />
    </div>
    <div class="form-group mt-3">
      <label for="email" class="d-block">Email</label>
      <input id="email" type="email" class="form-control rounded-0" v-model="email" />
    </div>
    <div class="form-group mt-3">
      <label for="password" class="d-block">Password</label>
      <input id="password" class="form-control rounded-0" v-model="password" :placeholder="passwordPlaceholder" />
    </div>
    <div class="form-group mt-3 text-right">
      <button class="btn btn-primary" @click="localSave">Save</button>
    </div>
  </div>
</template>
